import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { ComponentsModule } from 'src/app/components/components.module';
import { BonusOffersComponent } from './bonus-offers.component';
import { DateDefaultFormatPipe } from 'src/app/pipes/date-format.pipe';


@NgModule({
  declarations: [
    BonusOffersComponent
  ],
  imports: [
    CommonModule,
    IonicModule,
    ReactiveFormsModule,
    ComponentsModule,
    DateDefaultFormatPipe,
  ]
})
export class BonusOffersModule { }